<script>
import CrudListVue from 'Support/components/crud/CrudList.vue';
import CommunicationRequest from 'Domain/communication/CommunicationRequest';
import DataTableDateColumnVue from 'Support/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import CommunicationMessageConfigColumnVue from './components/CommunicationMessageConfigColumn.vue';
import CommunicationStatusColumnVue from './components/CommunicationStatusColumn.vue';

export default {
  name: 'CommunicationList',
  extends: CrudListVue,
  data() {
    return {
      editRoute: 'communicationEdit',
      requestClass: CommunicationRequest,
      headers: [
        {
          text: 'ID',
          value: 'id',
        },
        {
          text: 'Status',
          value: 'status',
          component: CommunicationStatusColumnVue,
        },
        {
          text: 'Título',
          value: 'titulo',
        },
        {
          text: 'Descrição',
          value: 'descricao',
        },
        {
          text: 'QTD. Usuários',
          value: 'listaClientesIds',
        },
        {
          text: 'SMS',
          value: 'smsConfigurado',
          component: CommunicationMessageConfigColumnVue,
        },
        {
          text: 'E-mail',
          value: 'emailConfigurado',
          component: CommunicationMessageConfigColumnVue,
        },
        {
          text: 'Push',
          value: 'pushConfigurado',
          component: CommunicationMessageConfigColumnVue,
        },
        {
          text: 'Criado por',
          value: 'criadoPorNome',
        },
        {
          text: 'Criado em',
          value: 'criadoEm',
          component: DataTableDateColumnVue,
        },
        {
          text: 'Atualizado por',
          value: 'alteradoPorNome',
        },
        {
          text: 'Atualizado em',
          value: 'atualizadoEm',
          component: DataTableDateColumnVue,
        },
      ],
    };
  },
  computed: {
    isPath() {
      return (path) => {
        const url = this.$route.path;
        return url.includes(path);
      };
    },
  },
  methods: {
    makeRequest() {
      if (this.isPath('logs')) {
        this.headers.push(
          {
            text: 'Agendado para',
            value: 'dataAgendamento',
            component: DataTableDateColumnVue,
          },
          {
            text: 'Enviado em',
            value: 'dataEnvio',
            component: DataTableDateColumnVue,
          },
        );
      }

      this.makeRestRequest();
    },
    mapItemMethod(item = {}) {
      return {
        ...item,
        listaClientesIds: this.getClientCount(item.listaClientesIds),
      };
    },
    getClientCount(list) {
      if (!list) {
        return 0;
      }

      if (Array.isArray(list)) {
        return list.length;
      }

      if (typeof list !== 'string') {
        return list;
      }

      try {
        const item = JSON.parse(list);
        return item.length;
      } catch (e) {
        return list;
      }
    },
    getFaultFilterList() {
      return {
        status: this.isPath('draft') ? 'RASCUNHO,AGUARDANDO_ENVIO' : 'ENVIADA,AGENDADA',
      };
    },
  },
};
</script>
